export const GET_CANDIDATE_INTERVIEW_LIST_DETAILS = "GET_CANDIDATE_INTERVIEW_LIST_DETAILS"
export const GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS = "GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS"
export const GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL = "GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL"